import module from 'viaticos/module.js'
import template from './template.html'
import {orderBy} from 'lodash'

export class ViaticosConfiguracionProyectoResponsablesComponent {
  agregando = false
  guardando = false
  idProyecto
  responsables = {
    requeridos: [],
    requeridosValidar: [],
    norequeridos: [],
  }
  responsablesAsignados = []
  tipoUsuario = undefined
  usuarios = []
  usuariosAsignados = []

  constructor(ViaticosCatalgosUsuariosService, ViaticosProyectoResponsableService, $state, $q) {
    this.ViaticosCatalgosUsuariosService = ViaticosCatalgosUsuariosService
    this.ViaticosProyectoResponsableService = ViaticosProyectoResponsableService
    this.$state = $state
    this.$q = $q
  }

  $onInit() {
    this.promise = this.$q.all({
        usuario: this.ViaticosCatalgosUsuariosService.get(),
        responsables: this.ViaticosProyectoResponsableService.get(this.idProyecto),
      })
      .then(({usuario, responsables}) => {
        this.usuarios = usuario.data
        this.responsablesAsignados = responsables.data
        this.filtrar()
      })
  }

  activarAgregar(tipoUsuario) {
    this.agregando = true
    this.tipoUsuario = tipoUsuario
  }

  actualizar(responsables, tipoUsuario) {
    switch (tipoUsuario) {
      case 1:
        this.responsables.norequeridos = this.responsables.norequeridos.concat(this.responsables.requeridos.filter((item) => !item.requerido))
        this.responsables.requeridos = this.responsables.requeridos.filter((item) => item.requerido)
        break
      case 2:
        this.responsables.requeridos = this.responsables.requeridos.concat(this.responsables.norequeridos.filter((item) => item.requerido))
        this.responsables.norequeridos = this.responsables.norequeridos.filter((item) => !item.requerido)
        break
      case 3:
        this.responsables.requeridos = this.responsables.requeridos.concat(this.responsables.requeridosValidar.filter((item) => item.requerido))
        this.responsables.requeridosValidar = this.responsables.requeridosValidar.filter((item) => item.requeridoValidar)
        break
    }
    this.responsablesAsignados = [
      ...this.responsables.requeridos,
      ...this.responsables.norequeridos,
      ...this.responsables.requeridosValidar,
    ]

    this.guardar(this.responsablesAsignados)
      .then(() => {
        this.filtrar()
      })
  }

  agregar(usuario) {
    if (!usuario) {
      this.agregando = false
      return
    }

    const responsable = Object.assign({}, usuario.usuario, {
      correo: usuario.correo,
      eliminado: false,
      finanzas: false,
      nominas: false,
      requerido: this.tipoUsuario === 1,
      requeridoValidar: this.tipoUsuario === 3,
    })
    this.responsablesAsignados.push(responsable)

    this.guardar(this.responsablesAsignados)
      .then(() => {
        this.agregando = false
        this.tipoUsuario = undefined
        this.filtrar()
      })
  }

  filtrar() {
    const usuariosAsignados = this.responsablesAsignados.map((item) => item.usuario)
    this.responsables.requeridos = this.responsablesAsignados.filter((item) => item.requerido)
    this.responsables.requeridos = orderBy(this.responsables.requeridos, 'posicion')
    this.responsables.norequeridos = this.responsablesAsignados.filter((item) => !item.requerido && !item.requeridoValidar)
    this.responsables.requeridosValidar = this.responsablesAsignados.filter((item) => item.requeridoValidar)
    this.usuariosAsignados = orderBy(this.usuarios.filter((item) => usuariosAsignados.indexOf(item.usuario) < 0), 'nombre')
  }

  guardar(responsables) {
    this.guardando = true
    return this.ViaticosProyectoResponsableService.put(this.idProyecto, responsables)
      .then(() => (this.guardando = false))
      .catch((e) => {
        this.error = true
        this.texterror = e.data
      })
  }

  regresar() {
    this.$state.go('.^')
  }
}

module.component('viaticosConfiguracionProyectoResponsables', {
  controller: ViaticosConfiguracionProyectoResponsablesComponent,
  template,
  bindings: {
    idProyecto: '<',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/configuracion/proyecto/responsables/component.js